var _circle, _circle2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBubblesElement = function SvgBubblesElement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 674,
    height: 666,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 321.625,
    cy: 352.447,
    r: 269,
    fill: "url(#bubbles-element_svg__paint0_linear)",
    fillOpacity: 0.2,
    opacity: 0.333,
    transform: "rotate(-10 321.625 352.447)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 296.421,
    cy: 373.776,
    r: 269,
    fill: "url(#bubbles-element_svg__paint1_linear)",
    fillOpacity: 0.2,
    opacity: 0.667,
    transform: "rotate(-5 296.421 373.776)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 393.245,
    r: 269,
    fill: "url(#bubbles-element_svg__paint2_linear)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bubbles-element_svg__paint0_linear",
    x1: -64.198,
    x2: 707.448,
    y1: 556.887,
    y2: 206.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#359AC0",
    stopOpacity: 0.82
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bubbles-element_svg__paint1_linear",
    x1: -89.402,
    x2: 682.244,
    y1: 578.216,
    y2: 227.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#359AC0",
    stopOpacity: 0.82
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bubbles-element_svg__paint2_linear",
    x1: -116.823,
    x2: 654.823,
    y1: 597.685,
    y2: 247.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#359AC0",
    stopOpacity: 0.82
  })))));
};
export { SvgBubblesElement as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NzQiIGhlaWdodD0iNjY2IiBmaWxsPSJub25lIiB2aWV3Qm94PSIwIDAgNjc0IDY2NiI+PGNpcmNsZSBjeD0iMzIxLjYyNSIgY3k9IjM1Mi40NDciIHI9IjI2OSIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyKSIgZmlsbC1vcGFjaXR5PSIuMiIgb3BhY2l0eT0iLjMzMyIgdHJhbnNmb3JtPSJyb3RhdGUoLTEwIDMyMS42MjUgMzUyLjQ0NykiLz48Y2lyY2xlIGN4PSIyOTYuNDIxIiBjeT0iMzczLjc3NiIgcj0iMjY5IiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXIpIiBmaWxsLW9wYWNpdHk9Ii4yIiBvcGFjaXR5PSIuNjY3IiB0cmFuc2Zvcm09InJvdGF0ZSgtNSAyOTYuNDIxIDM3My43NzYpIi8+PGNpcmNsZSBjeD0iMjY5IiBjeT0iMzkzLjI0NSIgcj0iMjY5IiBmaWxsPSJ1cmwoI3BhaW50Ml9saW5lYXIpIiBmaWxsLW9wYWNpdHk9Ii4yIi8+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyIiB4MT0iLTY0LjE5OCIgeDI9IjcwNy40NDgiIHkxPSI1NTYuODg3IiB5Mj0iMjA2LjQxOCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIHN0b3AtY29sb3I9IiMwMEIzOUYiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMzNTlBQzAiIHN0b3Atb3BhY2l0eT0iLjgyIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXIiIHgxPSItODkuNDAyIiB4Mj0iNjgyLjI0NCIgeTE9IjU3OC4yMTYiIHkyPSIyMjcuNzQ4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agc3RvcC1jb2xvcj0iIzAwQjM5RiIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzM1OUFDMCIgc3RvcC1vcGFjaXR5PSIuODIiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQyX2xpbmVhciIgeDE9Ii0xMTYuODIzIiB4Mj0iNjU0LjgyMyIgeTE9IjU5Ny42ODUiIHkyPSIyNDcuMjE2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agc3RvcC1jb2xvcj0iIzAwQjM5RiIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzM1OUFDMCIgc3RvcC1vcGFjaXR5PSIuODIiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48L3N2Zz4=";